<template>
  <div class="vehicle-info">
    <div id="vehicle-info">
      <div class="loader d-flex justify-content-center" v-if="item == null"><b-spinner :label="$t('common_phrases.loading')"></b-spinner></div>
    
      <div class="detail-view" v-if="item != null">
        
        <h4>
            {{name}}
            <a href="#" class="action-link" @click="editVehicle" v-b-tooltip :title="$t('map.buttons.edit_vehicle')"><b-icon icon="gear-fill" scale="1.0"></b-icon></a>
        </h4>

        <b-collapse id="collapse-3" class="mt-2" :visible="historySelectorVisible == false && !vehicleStatusOnRoute">
        
        <div>
          <b-row v-if="this.spatialData == null" class="no_spatial_info">
            <b-col><b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>{{$t('map.warnings.location_lack')}}</b-col>
          </b-row>

          <div class="attr-table" v-if="this.spatialData != null">
            <!-- <b-row><b-col>{{$t('map.label.number')}}</b-col><b-col>{{name}}</b-col></b-row> -->
            <!--  <b-row><b-col>{{$t('map.label.organization')}}</b-col><b-col>{{organisation}}</b-col></b-row> -->
            <card>
              <b-row><b-col>{{$t('map.tooltip.type')}}</b-col><b-col>{{vehicleType}}</b-col></b-row>
              <b-row v-if="$UiConfig('/data/vehicle/showObu', true)"><b-col>{{$t('map.tooltip.computer')}}</b-col><b-col>{{vehicleComputerType}}</b-col></b-row>
              <b-row><b-col>{{$t('vehicle.gps_time')}}</b-col><b-col :class="vehicleRTDetail && 'lastseen-alert'">{{ formattedGpsTime }}</b-col></b-row>
              <b-row><b-col>{{$t('vehicle.server_time')}}</b-col><b-col :class="vehicleRTDetail && 'lastseen-alert'">{{ serverTimestamp }}</b-col></b-row>
              <b-row><b-col>{{$t('vehicle.technical_number')}}</b-col><b-col>{{vehicleID}}</b-col></b-row>
              <hr>
            </card>
            
            <card>
              <b-row><b-col>{{$t('map.tooltip.block_sequence')}}</b-col><b-col>{{blockSequence}}</b-col></b-row>
              <b-row v-if="$UiConfig('/data/departure/showCourse', false)"><b-col>{{ $t('map.tooltip.course') }}</b-col><b-col>{{ tripShortName }}</b-col></b-row>
              <b-row v-if="$UiConfig('/data/departure/showCourse', false)"><b-col>{{ $t('map.tooltip.next_course') }}</b-col><b-col>{{ nextTripShortName }}</b-col></b-row>
              <b-row><b-col>{{$t('map.tooltip.line')}}</b-col><b-col>{{lineLabel}}</b-col></b-row>
              <b-row><b-col>{{$t('map.tooltip.destination')}}</b-col><b-col>{{destination}}</b-col></b-row>
              <b-row><b-col>{{$t('map.tooltip.schedule')}}</b-col><b-col>{{deviation}}</b-col></b-row>
              <b-row><b-col>{{$t('map.tooltip.speed')}}</b-col><b-col>{{speed}}</b-col></b-row>
              <b-row><b-col>{{$t('vehicle.dep_time')}}</b-col><b-col>{{departureTime}}</b-col></b-row>
              <b-row v-if="$UiConfig('/data/departure/showFirstLastStop', false)"><b-col>{{$t('map.tooltip.first_last_stop')}}</b-col><b-col>{{ firstLastStop }}</b-col></b-row>
              <b-row v-if="$UiConfig('/data/departure/showWaitingTimeOnLoop', false)"><b-col>{{$t('map.tooltip.waiting_time_on_loop')}}</b-col><b-col>{{ waitingTimeOnLoop }}</b-col></b-row>
            </card>
          </div>

          <card v-if="$UIPrivilege('realtime/vehicleRtStatus')" class="vehRealtimeDetailsCard">
            <VehicleRealtimeDetails v-if="this.spatialData != null" 
              :key="this.item.vehicleId" 
              :itemId="this.item.vehicleId" 
              ></VehicleRealtimeDetails>
          </card>

          <card class="attr-table">
            <VehicleOrganizationFeatures  :vehicle="item"></VehicleOrganizationFeatures>
          </card>
          <card class="attr-table" v-if="this.spatialData && this.spatialData.properties && this.spatialData.properties.extraInfo && this.item && this.item.features && this.item.features.CAN_DATA == 'true'"
>
            <VehicleCANData :itemId="this.item.vehicleId"/>
          </card>
          <div class="buttons">
          <!-- <p-button v-if="vehicleStatusOnRoute" size="sm" outline @click="vehicleStatusOnRoute = false" v-b-tooltip :title="$t('map.vehicleHistory.label')"><b-icon icon="info-circle" scale="1.0"></b-icon></p-button> -->
            <card class="actionsCard">
              {{$t('vehicle.actions')}}
              <p></p>
              <CallButton :recipient="item.features.SIP_CLIENT_ID ? item.features.SIP_CLIENT_ID : null" />
              <p-button v-if="$UIPrivilege('map/vehicles', 'route') && !vehicleStatusOnRoute" size="sm" outline @click="vehicleStatusOnRoute = true" v-b-tooltip :title="$t('departure.departures')"><b-icon icon="bezier2" scale="1.0"></b-icon></p-button>
              <p-button v-if="$UIPrivilege('map/vehicles', 'history')" size="sm" outline @click="onVehicleHistory()" v-b-tooltip :title="$t('map.vehicleHistory.label')"><b-icon icon="clock-history" scale="1.0"></b-icon></p-button>
              <p-button v-if="$UIPrivilege('map/vehicles', 'message')" size="sm" outline @click="vehicleMessage()" v-b-tooltip :title="$t('dispatching.messages.message')"><b-icon icon="chat-text" scale="1.0"></b-icon></p-button>
            </card>
          </div>
        </div>

        
      </b-collapse>
      </div>
    </div>

     <div v-if="vehicleStatusOnRoute">
           <VehicleStatusOnRoute :vehicleLabel="this.item.vehicleLabel" v-if="this.blockSequence != ''"></VehicleStatusOnRoute>
          <div class="buttons" style="text-align:left">
             <p-button  v-if="vehicleStatusOnRoute" size="sm" outline @click="vehicleStatusOnRoute = false" v-b-tooltip :title="$t('button.close')"><b-icon icon="x" scale="1.5"></b-icon></p-button>
          </div>
         
        </div>

    <!--
    <b-collapse id="collapse-2" class="mt-2" :visible="vehicleStatusOnRoute == true">
      <hr>
      <VehicleStatusOnRoute :vehicleLabel="this.item.vehicleLabel" v-if="this.blockSequence != ''"></VehicleStatusOnRoute>
    </b-collapse>
    -->
    <b-collapse id="collapse-1" class="mt-2" v-model="historySelectorVisible">
      <VehicleHistorySelector :computerLabel="this.item.computerLabel" v-if="this.item != null" @close="historySelectorVisible = false" @ok="this.vehicleHistoryLoaded"></VehicleHistorySelector>
    </b-collapse>
  
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
import timetable from '@/store/timetable/timetable'
import VehicleStatusOnRoute from '@/components/Map/VehicleStatusOnRoute'
import VehicleOrganizationFeatures from '@/components/Realtime/VehicleOrganizationFeatures'
import VehicleHistorySelector from '@/components/Realtime/VehicleHistorySelector'
import VehicleRealtimeDetails from '@/components/Realtime/VehicleRealtimeDetails'
import CallButton from '@/components/Dispatching/VoIP/CallButton.vue';
import olf from '@/components/Map/OpenLayersFunctions.js'
import moment from 'moment';
import realtimeLogic from '@/services/realtimeLogic';
import VehicleCANData from '@/components/Realtime/VehicleCANData.vue';

export default {
  name: 'MapVehicleDetails',
  components: {
    VehicleStatusOnRoute,
    VehicleOrganizationFeatures,
    VehicleRealtimeDetails,
    VehicleHistorySelector,
    VehicleCANData,
    CallButton
  },
  data: function() {
    return {
      item: null,
      routeData: null,
      intervalId: null,
      historySelectorVisible: false,
      vehicleStatusOnRoute: false,
      vehicleRTDetail: null,
      spatialData: null,
      formattedGpsTime: ''
    }
  },
  props: {
   // msg: String
    itemId: {default: null}
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
    if (!this.$store.state.timetable) {
      this.$store.registerModule("timetable" , timetable);
    }
  },
  beforeDestroy() {
        clearInterval(this.interval);
  },
  mounted() {
      this.$store.dispatch('mapstore/getVehiclesForTable').then(
      (data) => {
        var found = null;
        var $vm = this;
        found = data.find((i)=>{
          try{
            return i.vehicleId == $vm.$props.itemId
          } catch(err) {/*typerä kääntäjä*/}
        });
        this.item = found;
        this.spatialData = found.spatialData;
        this.fetchDestination();
      },
      ()=>{ 
      /* error hanskaus */
      });
      this.fetchVehicleDetail(this.$store.state.mapstore.vehiclesForTable);
      this.interval = setInterval(() => { 
        this.$store.dispatch('mapstore/getVehiclesForTable', 30) 
      }, 3000); 
  },

  watch: {
    runningRouteTunnus: function() {
      this.$emit('vehiclesRoute', this.runningRouteTunnus );
    },
    vehiclesForTable(newValue) {
      this.fetchVehicleDetail(newValue);
    }
  },
  computed: {
    vehiclesForTable() {
      return this.$store.state.mapstore.vehiclesForTable;
    },
    name: function() {
      try {
        return this.item.vehicleLabel;
      } catch(err) {
        return "";
      }
    },
    organisation: function() {
       try {
        return this.item.organization;
      } catch(err) {
        return "";
      }
    },
    vehicleType: function() {
      try {
        return this.spatialData.properties.vehicleFeatures.vehicle_type;
      } catch(err) {
        return "";
      }
    },
    vehicleID: function() {
      try {
        return this.spatialData.properties.vehicleId;
      } catch(err) {
        return "";
      }
    },
    vehicleComputerType: function() {
      try {
        return this.spatialData.properties.vehicleFeatures.vehicle_computer_type;
      } catch(err) {
        return "";
      }
    },
    blockSequence: function() {
      try {
        return this.spatialData.properties.blockSequence;
      } catch(err) {
        return "";
      }
    },
    lineLabel: function() {
      try {
        return this.spatialData.properties.lineLabel;
      } catch(err) {
        return "";
      }
    },
    destination: function() {
      try{
        if(this.routeData.destination){
          return this.routeData.destination;
        }else{
          return this.routeData.routestops[this.routeData.routestops.length - 1].nimi
        }
      } catch(err){
        return "";
      }
    },
    runningRouteTunnus: function() {
      try{
        if(this.routeData.tunnus)
          return this.routeData.tunnus;
      } catch(err){
        return null;
      }
      return null;
    },
    deviation: function() {
      try {
        return realtimeLogic.getDeviationInRightFormat(this.spatialData.properties.lastSeenTime, this.spatialData.properties.deviation, this.blockSequence);
      } catch(err) {
        return "";
      }
    },
    lastSeenTime() {
        let time = "";
        try {
            time = new moment(this.spatialData.properties.gpsTimestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm:ss');
            if (time.startsWith('Invalid')) time = "";
        } catch(err) {
            time = ""
        }
        return time;
    },
    timeLimitExceeded() {
        if (this.spatialData != null)
            return olf.timeLimitExceeded(this.spatialData.properties.gpstimestamp);
        else
            return null;
    },

    serverTimestamp() {
        if (this.spatialData != null)
            return olf.formatTimestamp(this.spatialData.properties.extraInfo.serverTimestamp);
        else
            return null;
    },

    gpsTimestamp() {
        if (this.spatialData != null)
            return olf.formatTimestamp(this.spatialData.properties.gpsTimestamp);
        else
            return null;
    },
    speed: function() {
      try {
        return (this.spatialData.properties.speed ? this.spatialData.properties.speed  + " " + this.$t('map.tooltip.speed_unit') : "-");
      } catch(err) {
        return "-";
      }
    },
    tripShortName: function() {
        try {
            return this.spatialData.properties.tripShortName;
        } catch(err) {
            return '';
        }
    },
    nextTripShortName: function() {
        try {
            return this.spatialData.properties.nextTripShortName;
        } catch(err) {
            return '';
        }
    },
    departureTime: function() {
        try {
            return olf.formatTimestamp(this.spatialData.properties.departureTime);
        } catch(err) {
            return '';
        }
    },
    firstLastStop: function() {
        try {
          if(this.spatialData.properties.firstStop && this.spatialData.properties.lastStop) {
            return this.spatialData.properties.firstStop + ' - ' + this.spatialData.properties.lastStop
          }
            return '';
        } catch(err) {
            return '';
        }
    },
    waitingTimeOnLoop: function() {
        try {
            return olf.getWaitingTimeInRightFormat(this.spatialData.properties.waitingTimeOnLoop);
        } catch(err) {
            return '';
        }
    }
  },
  
  methods: {
    fetchVehicleDetail(data) {
      const found = data.find(i => i.vehicleId == this.itemId);
      if (found && found.spatialData) {
        this.vehicleRTDetail = found;
        this.spatialData = found.spatialData;
        this.formattedGpsTime = this.formatTimestamp(this.spatialData.properties.gpsTimestamp);
      }
    },
    formatTimestamp(timestamp) {
      timestamp = olf.formatTimestamp(timestamp)
      return timestamp;
    },
    hideItemDetails: function() {
      this.$emit('hideItemDetails');
    },
    editVehicle: function() {
      this.$router.push({ path: '/realtime/vehicles', query: { vehicleLabel: this.item.vehicleLabel }});
    },
    fetchDestination: function() {
      if(this.spatialData != null && this.spatialData.properties.routeId){
        this.$store.dispatch('timetable/getRouteStops',this.spatialData.properties.routeId).then(
        (data)=>{
          try{
            this.routeData = data.data;
          }catch(err){
            this.routeData = null;
          }
        },
        () => {
          /* Error getting data. Do nothing */
        }
      )
      }
    },
    vehicleMessage(){
      this.$router.push({ path: '/dispatching/usermessages', query: { vehicle: this.itemId }});
    },
    vehicleHistoryLoaded(selectedDate) {
      this.$emit('vehicleHistoryLoaded', selectedDate); 
    },
    onVehicleHistory() {
      this.historySelectorVisible = !this.historySelectorVisible
      this.$store.commit('mapstore/setActiveVehicleHistoryDetails' , null )
    }
  }
}
</script>

<style scoped lang="scss">

.vehicle-info {
  max-height: 100%;
  overflow:scroll;
}

.actionsCard {
   text-align: left;
}

.orgFeaturesCard {
  font-weight:normal;
}

</style>